export const API_URL:string = import.meta.env.VITE_API_URL;
export const PUBLIC_URL:string = import.meta.env.VITE_PUBLIC_URL;

export const flagUrls: Record<string, string> = {
  "da-dk": '/imgs/flag_da.svg',
  "en-gb": '/imgs/flag_en.svg',
  "sv-se": '/imgs/flag_sv.svg'
}

